// src/pages/Dashboard.js
import React, { useState, useEffect, useMemo } from "react";
import { Typography, Grid } from "@mui/material";
import { GradientButton } from "components/GradientButton";
import SaveIcon from "@mui/icons-material/Save";
import useProductData from "pages/Pawn/Report/Interest/data/data";
import useColumns from "pages/Pawn/Report/Interest/columns/mainColumns";
import dayjs from "dayjs";
import SearchBar from "components/TableExplanded/SearchBar";
import CustomTable from "components/TableExplanded/TableSpecial";
import api from "_api";

const Interest = ({ className }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedProduct, setProduct] = useState(null);
  const [fetchData, setFetchData] = useState([]);
  const [searchQuery, setSearchQuery] = useState(""); // Store the search query
  const [viewProduct, setViewProduct] = useState(null);
  const [isViewModalOpen, setViewModalOpen] = useState(false);

  const fetchProductData = async () => {
    try {
      const response = await api.product.getInterest();
      // console.log("data API", response);
      if (response) {
        // console.log("data API123123", response);
        setFetchData(response);
      }
    } catch (error) {
      console.error("Error fetching product data:", error);
    }
  };

  useEffect(() => {
    fetchProductData();
  }, []);

  const handleModalOpen = () => {
    setModalOpen(!isModalOpen);
    if (selectedProduct && isModalOpen) setProduct(null);
  };
  const handleViewOpen = () => {
    setViewModalOpen(!isViewModalOpen);
    if (viewProduct && isViewModalOpen) setViewProduct(null);
  };
  const data = useProductData(fetchData);
  const columns = useColumns(
    setViewProduct,
    setProduct,
    handleViewOpen,
    handleModalOpen
  );
  const visibleColumns = columns.filter((col) => col.showInFilter);

  const filteredData = useMemo(() => {
    if (!searchQuery) return data; // If no search query, return all data

    return data.filter((row) => {
      return visibleColumns.some((column) => {
        const cellValue = row[column.accessor]?.toString()?.toLowerCase();
        return cellValue && cellValue.includes(searchQuery.toLowerCase());
      });
    });
  }, [data, searchQuery, visibleColumns]);

  const handleSearchChange = (event) => {
    // Check if event.target and event.target.value are defined
    if (
      event &&
      event.target &&
      event.target.value !== undefined &&
      event.target.value !== null
    ) {
      setSearchTerm(event.target.value.toLowerCase());
      setSearchQuery(event.target.value);
    } else {
      console.error("Event target or value is undefined");
    }
  };

  const handleClear = () => {
    setSearchTerm("");
  };

  const handleExportExcel = async () => {
    await api.report
      .exportExcelInterest()
      .then((res) => {
        const contentDisposition = res.headers["content-disposition"];
        let filename = "download.xlsx"; // Default กรณีไม่มีชื่อไฟล์จาก API

        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?(.+?)"?$/);
          if (match && match[1]) {
            filename = match[1];
          }
        }

        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.error("Error exporting excel:", error);
      });
  };

  return (
    <div className={className}>
      <Grid container spacing={10} style={{ marginBottom: "16px" }}>
        <Grid
          item
          xs={12}
          sm={12}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography component="div" style={{ fontSize: "32px" }}>
            ดอกเบี้ย
          </Typography>

          <GradientButton
            onClick={handleExportExcel}
            sx={{
              px: 3,
              display: "flex",
              alignItems: "center",
              height: "48px",
            }}
          >
            <Typography style={{ marginRight: "8px" }}>ส่งออก Excel</Typography>
            <SaveIcon fontSize="medium" />
          </GradientButton>
        </Grid>
      </Grid>
      {/* <SearchBar
        columns={columns}
        searchTerm={setSearchTerm}
        visibleColumns={visibleColumns} // กรองคอลัมน์ที่ต้องการแสดง
        handleSearchChange={handleSearchChange}
        handleClear={handleClear}
        fetchData={fetchData}
        QRCode={false}
      /> */}
      <CustomTable columns={columns} data={filteredData} />
    </div>
  );
};

export default Interest;
